<template>
    <div>TEST</div>
</template>

<script>
    export default {
        name: "HotSpot Users"
    }
</script>

<style scoped>

</style>